import { jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { useJobDetailsViewContext } from "../CompanyProfile/CompanyProfile.mjs";
import { useInView } from "react-intersection-observer";
import { JobCardLite } from "./JobCardLite/JobCardLite.mjs";
import { jobCardWrapper, jobCardWrapperForScrollOnTablet } from "./CompetitiveJobs.css.mjs";
const InViewTracker = ({
  trackCallback,
  children
}) => {
  const { ref: trackedComponent } = useInView({
    onChange(inView) {
      if (inView) {
        trackCallback();
      }
    },
    threshold: 0.5,
    triggerOnce: true
  });
  return /* @__PURE__ */ jsx(Box, { ref: trackedComponent, children });
};
const defaultUseToggleSaveJob = () => ({
  isSaved: false,
  isApplied: false,
  toggleSavedJob: () => {
  }
});
const CompetitiveJobCard = ({
  isEnableHorizontalScroll,
  wrapperPaddingRight,
  trackCallback,
  ...cardProps
}) => {
  const {
    useCompetitivePlacementToggleSaveJob: useToggleSaveJob = defaultUseToggleSaveJob
  } = useJobDetailsViewContext();
  const saveJob = useToggleSaveJob({ jobId: cardProps.id });
  return /* @__PURE__ */ jsx(
    Box,
    {
      flexGrow: 1,
      className: [
        jobCardWrapper,
        {
          [jobCardWrapperForScrollOnTablet]: isEnableHorizontalScroll
        }
      ],
      paddingRight: wrapperPaddingRight,
      children: trackCallback ? /* @__PURE__ */ jsx(InViewTracker, { trackCallback, children: /* @__PURE__ */ jsx(JobCardLite, { ...cardProps, saveJob }) }) : /* @__PURE__ */ jsx(JobCardLite, { ...cardProps, saveJob })
    }
  );
};
export {
  CompetitiveJobCard
};
